import React from "react";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";
import NoPermissionIlustration from "../../assets/img/no-permissions-illustration.svg";
import "./style.css";

const NoPermissionsView = () => {
  const navigate = useNavigate();
  return (
    <div className="noPermissionsOuterContainer">
      <div className="noPermissionsContainer">
        <img className="noPermissionsImg" src={NoPermissionIlustration} alt="no-permissions"/>
        <p className="noPermissionsMessage"><FormattedMessage id="deadlines.noPermissions" /></p>
        <div className="goBackLink" onClick={() => navigate(-1)}><FormattedMessage id="deadlines.noPermissionsGoBack" /></div>
      </div>
    </div>
  );
};

export default NoPermissionsView;